import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Input } from "antd";
import { observer } from "mobx-react-lite";
import { useStores } from "../../../../../../../store/root.js";
import { mergeStyles } from "../../../../../../../util/style.js";
import { getPathInfo } from "../../../../../../../util/template/form.js";
import { getFormPropsByLanguage, getInputPropsByLanguage, getTranslationFlagElementStyle, hasTranslationFlagsChanged, onTranslationValueChange } from "../../../../../../../util/translation.js";
import { LanguageIcon } from "../language-icon-addon/language-icon.js";
const TranslationInputFormFieldEntry = observer(({ lang, flexPathConfig, customPlaceholder, formProps, inputProps })=>{
    const form = Form.useFormInstance();
    const { rcbUserSettingsStore: { settings: { translationSettings } } } = useStores();
    const dynamicFormProps = getFormPropsByLanguage(lang, translationSettings);
    const inputInfo = getPathInfo(flexPathConfig, lang);
    return /*#__PURE__*/ _jsx(Form.Item, {
        shouldUpdate: (prev, next)=>hasTranslationFlagsChanged(prev, next, inputInfo.flagNamePath),
        noStyle: true,
        children: ()=>{
            const flagStyle = getTranslationFlagElementStyle(form, inputInfo.flagNamePath);
            const dynamicInputProps = getInputPropsByLanguage(lang, translationSettings);
            dynamicInputProps.style = mergeStyles(dynamicInputProps.style, flagStyle);
            return /*#__PURE__*/ _jsx(Form.Item, {
                name: inputInfo.namePath,
                hasFeedback: true,
                noStyle: true,
                ...dynamicFormProps,
                ...formProps,
                children: /*#__PURE__*/ _jsx(Input, {
                    placeholder: inputProps?.placeholder || customPlaceholder?.(lang),
                    style: {
                        ...inputProps?.style,
                        ...dynamicInputProps?.style
                    },
                    ...inputProps,
                    ...dynamicInputProps,
                    onChange: ()=>{
                        onTranslationValueChange(form, inputInfo.flagNamePath, lang);
                    },
                    suffix: /*#__PURE__*/ _jsx(LanguageIcon, {
                        lang: lang,
                        flexPathConfig: flexPathConfig
                    })
                })
            }, inputInfo.key);
        }
    }, `${inputInfo.key}-wrapper`);
});
export { TranslationInputFormFieldEntry };
